"use strict";

let env = {
  $window: window,
  $html: document.getElementsByTagName("html")[0],
  $mainContent: document.getElementById("barba-wrapper"),
  $body: document.body,
  $master: document.getElementById("master"),
  $mainNav: document.getElementById("jsView--mainnav"),
  $mainTransition: document.getElementById("jsView--transition"),
  $mainTransitionProgress: document.getElementById("jsView--progress"),
  $launcher: document.getElementById("jsLauncher"),
  framework: {},
  tablet: false,
  mobile: false,
  phone: false,
  desktop: false,
  ios: false,
  ie11: false,
  edge: false,
  orientation: false,
  isVisiting: false,
  isOldie: false,
  isTouch: "ontouchstart" in window,
  zIndexHover: 100,
};

export default env;
